<template>
  <el-container style="height: 100%; border: 1px solid #eee">
    <el-aside width="270px" style="background-color: transparent">
      <el-menu :default-openeds="['1']" :router="true" >
        <el-menu-item v-if="this.createuserid==0" index="/HomePage/PJGLHomepage/AduitAward_Manager"><i class="el-icon-star-on"></i>评奖管理</el-menu-item>

        <el-submenu v-if="this.createuserid==1" index="1">
          <template slot="title"><i class="el-icon-star-on"></i>评奖管理</template>
          <el-menu-item  index="/HomePage/PJGLHomepage/AduitAward_Company">项目总览</el-menu-item>
<!--          <el-menu-item index="/HomePage/PJGLHomepage/PrimaryInfo_01">项目基本情况</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/ProjectAbstract_02">项目简介</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/PrimaryScienceInnovate_03">主要科技创新</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/ThirdPartyEvaluation_04">第三方评价</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/ProjectInfluence_05">推广应用情况、经济效益和社会效益</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/AcquiredAward_06">曾获科技奖励情况</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/IntellectualProperty_07">主要知识产权证明目录</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/Thesis_08">论文专著目录</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/CompletePerson_09">主要完成人情况表</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/CompleteCompany_10">主要完成单位情况表</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/RecommendOpinions_11">推荐单位意见</el-menu-item>
          <el-menu-item index="/HomePage/PJGLHomepage/attachment_12">附件</el-menu-item>-->
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container style="height: 100%;width:100%;padding: 10px;border: 1px solid rgb(246, 246, 247);box-sizing: border-box;background-color:rgb(246, 246, 247) ">
      <router-view></router-view>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "PJGLHomepage",
  data(){
    return{
      createuserid:-1
    }
  },
  methods:{

  },
  created() {
    this.createuserid=sessionStorage.getItem('createuserid')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PJGL/PJGLHomepage.vue